import React, { createContext, useContext, useEffect, useState } from "react";

import { useLeave } from "./LeaveContext";
import { useAuth } from "./AuthContext";
import { normalizeRole } from "../utils/roleUtils";



const ApprovalNotificationContext = createContext(null);

export function useApprovalNotifications() {
  const context = useContext(ApprovalNotificationContext);

  if (!context) {
    throw new Error(
      "useApprovalNotifications must be used inside ApprovalNotificationProvider"
    );
  }

  return context;
}

export function ApprovalNotificationProvider({ children }) {
  const { userProfile } = useAuth();
const {
  teamRequests,
  allRequests,
} = useLeave();

  const [counts, setCounts] = useState({
    leave: 0,
    expense: 0,
    travel: 0,
    asset: 0,
    total: 0,
  });

  useEffect(() => {
  if (!userProfile) return;

  let leaveCount = 0;
  const normRole = normalizeRole(userProfile.role);

  if (normRole === "lead") {
    leaveCount = teamRequests.length;
  } else if (normRole === "admin") {
    leaveCount = allRequests.filter((request) =>
      ["pending_admin", "pending_lead"].includes(request.status)
    ).length;
  }

  setCounts({
    leave: leaveCount,
    expense: 0,
    travel: 0,
    asset: 0,
    total: leaveCount,
  });
}, [userProfile, teamRequests, allRequests]);

    useEffect(() => {
  console.log("Approval Counts:", counts);
}, [counts]);

  return (
    <ApprovalNotificationContext.Provider
      value={{
        counts,
      }}
    >
      {children}
    </ApprovalNotificationContext.Provider>
  );
}